import React from 'react'
import { Link } from 'react-router-dom'

const ThankYou = () => {
  return (
    <>
        <section className='thank-you-wrap'>
            <div className='container'>
                <div className='thank-you-block text-center'>
                    <h1 className='lg-title text-center mb-4'>Thank you for your interest in Alpha One Motors <br/>
Our representative will be in contact with you shortly.</h1>
                    <div className='mt-5 text-center'>
                      <Link to="/" className='black-btn get-started-btn w-240 text-uppercase d-inline-block reveal wow fadeInUp'>Go Back</Link>
                    </div>
                </div>
            </div>
        </section>
    </>
  )
}

export default ThankYou